export const COMPOSER_OVERLAY_CONTENT_CLASS =
  'rounded-xl border border-border/60 bg-popover/95 text-popover-foreground shadow-elevation-3 backdrop-blur-xl';

// Use the Radix available-height CSS vars when present, but keep a viewport
// fallback so surfaces that opt out of collision handling still share the same
// overall size contract.
export const COMPOSER_POPOVER_MAX_HEIGHT_CLASS =
  'max-h-[min(var(--radix-popover-content-available-height,80vh),28rem)]';

export const COMPOSER_DROPDOWN_MAX_HEIGHT_CLASS =
  'max-h-[min(var(--radix-dropdown-menu-content-available-height,80vh),28rem)]';

export const COMPOSER_OVERLAY_SCROLL_BODY_CLASS = 'overflow-y-auto overscroll-contain';
